import { createContext, useContext, useState } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';

const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
    const [notifications, setNotifications] = useState([]);

    const addNotification = (message, variant = 'success') => {
        setNotifications(prev => [...prev, { id: Date.now(), message, variant }]);
    };

    const removeNotification = id => {
        setNotifications(prev => prev.filter(notification => notification.id !== id));
    };

    return (
        <NotificationContext.Provider value={{ addNotification }}>
            {children}

            <ToastContainer position="top-end" className="p-3">
                {notifications.map(notification => (
                    <Toast key={notification.id} autohide delay={3000} onClose={() => removeNotification(notification.id)} bg={notification.variant} className="mb-2">
                        <Toast.Body style={{ color: 'white' }}>{notification.message}</Toast.Body>
                    </Toast>
                ))}
            </ToastContainer>
        </NotificationContext.Provider>
    );
};

export const useNotification = () => {
    const context = useContext(NotificationContext);
    if (!context) {
        throw new Error('useNotification deve ser usado dentro de um NotificationProvider');
    }
    return context;
};
